import { FetchProductsRoutine, DeleteProductRoutine, CreateProductRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const productsListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchProductsRoutine.REQUEST:
    case CreateProductRoutine.REQUEST:
    case DeleteProductRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchProductsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case CreateProductRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: [...state.data, action.payload],
      };
    case DeleteProductRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
      };
    case CreateProductRoutine.FAILURE:
    case FetchProductsRoutine.FAILURE:
    case DeleteProductRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
